import { type Theme } from "@mui/material";

export function getPayTextColor(theme: Theme, status: string): string | undefined {
  if (status === "pending") {
    return theme.palette.intent?.warning.text;
  }

  if (status === "declined" || status === "expired") {
    return theme.palette.intent?.error.text;
  }

  return undefined;
}
